import React from 'react'
import { useViewport } from '../../../utils'
import { Metas } from '.'
import { ChevronDown, ChevronUp } from 'react-feather'
import { ButtonBookmarkIcon } from '../../../components'
import CardAvatar from './card-avatar'
import CardFeaturedPrograms from './card-featured-programs'

const ChevronWrapper = ({children, className, ...props}) => (
  <div
    className={`w-full flex justify-center items-center ${className}`}
    {...props}
  >
    {children}
  </div>
)

const Card = ({data, bookmark}) => {
  const { name, logo } = data
  const [isOpen, setIsOpen] = React.useState(false)
  const { isDesktop, isMobile } = useViewport()

  const handleToggle = (e) => {
    e.preventDefault()
    e.stopPropagation()

    setIsOpen(!isOpen)
  }

  return (
    <div
      className="rounded p-4 lg:p-8 relative"
      style={{boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'}}
    >
      <div className="flex">
        <CardAvatar image={logo} bookmark={bookmark}/>
        <div className="w-full">
          <div className="flex justify-between">
            <h3 className={`font-bold lg:text-2xl font-primary ${bookmark ? 'mb-5' : 'mb-3'} leading-tight`}>
              {name}
            </h3>
            { bookmark && <ButtonBookmarkIcon /> }
          </div>

          <Metas
            data={data}
            isDesktop={isDesktop}
            isOpen={isOpen}
          />

          {
            (!bookmark && !isMobile) &&
            <CardFeaturedPrograms programs={data.featured_programs} />
          }
        </div>
      </div>
      {
        isMobile && (
          <ChevronWrapper onClick={handleToggle}>
            {
              isOpen ?
              <ChevronUp width={14}/> :
              <ChevronDown width={14}/>
            }
          </ChevronWrapper>
        )
      }
    </div>
  )
}

export { Card }
